import React, { useState, useEffect, useMemo, useContext } from 'react'
import lodash from 'lodash'

import PrinterContext from '../../contexts/PrinterContext'

const usePrinters = () => {
  const { currentPrinter, printers } = useContext(PrinterContext)

  const currentPrinterName = lodash.get(printers, currentPrinter)

  return {
    currentPrinterId: currentPrinter,
    currentPrinter: currentPrinterName
      ? {
          name: currentPrinterName,
          id: currentPrinter
        }
      : undefined,
    printers
  }
}

export default usePrinters
